export default {"src":"/_next/static/media/normal_arrow.2223bfc5.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};